<script setup>
import {
  mdiCheck,
  mdiEyeOutline,
  mdiCheckboxMarkedCircleAutoOutline,
  mdiCheckboxMarkedCirclePlusOutline,
  mdiTextBoxOutline,
  // mdiUpload
} from '@mdi/js'
import { onBeforeUnmount, ref, reactive, watch } from 'vue'
import CardBox from '@/components/CardBox.vue'
import BaseDivider from '@/components/BaseDivider.vue'
import CardBoxModal from '@/components/CardBoxModal.vue'
import NotificationBar from '@/components/NotificationBar.vue'
import FormField from '@/components/FormField.vue'
import FormControl from '@/components/FormControl.vue'
import FormControlFile from '@/components/FormControlFile.vue'
import LoaderFullPage from '@/components/LoaderFullPage.vue'
import BaseButtons from '@/components/BaseButtons.vue'
import BaseLevel from '@/components/BaseLevel.vue'
import { useRouter } from 'vue-router'
import BaseButton from '@/components/BaseButton.vue'
import { useUserStore } from '@/stores/user_store'
import { useTasksStore } from '@/stores/tasks'

import { parseTimestamp, parseDate } from '@/timestamp-options'

const userStore = useUserStore()
const tasksStore = useTasksStore()

defineProps({
  task: {
    type: Object,
    required: false
  },
  canComplete: {
    type: Boolean,
    default: true
  },
  canTake: {
    type: Boolean,
    default: true
  }
})
const router = useRouter()
const loadingVisible = ref(false)
const isModalManualActive = ref(false)
const isModalFilesActive = ref(false)
const isModalCompleteActive = ref(false)
const isModalErrorActive = ref(false)
const taskCompleteAmount = ref(0)

// const MAX_COMPLETE_FILES = 10

// const completeImagesInput = ref(null)
const completeSelectedFiles = ref([]) // File[]
// const completePreviewUrls = ref([]) // string[]

// function revokeCompletePreviewUrls() {
//   completePreviewUrls.value.forEach((url) => URL.revokeObjectURL(url))
//   completePreviewUrls.value = []
// }

function resetCompleteImages() {
  completeSelectedFiles.value = []
}

// function onCompleteImagesChange(event) {
//   errors.state = false
//   errors.errorText = ''

//   const files = Array.from(event.target?.files || [])
//   if (!files.length) return

//   // Разрешаем добавлять и одно, и несколько фото за раз (без сброса уже выбранных).
//   const remaining = MAX_COMPLETE_FILES - completeSelectedFiles.value.length
//   if (remaining <= 0) {
//     errors.state = true
//     errors.errorText = `Лимит: максимум ${MAX_COMPLETE_FILES} фото`
//     if (completeImagesInput.value) {
//       completeImagesInput.value.value = null
//     }
//     return
//   }

//   const filesToAdd = files.slice(0, remaining)
//   const isOverLimit = files.length > remaining

//   filesToAdd.forEach((file) => {
//     completeSelectedFiles.value.push(file)
//     completePreviewUrls.value.push(URL.createObjectURL(file))
//   })

//   if (isOverLimit) {
//     errors.state = true
//     errors.errorText = `Лимит: максимум ${MAX_COMPLETE_FILES} фото`
//   }

//   // Чтобы можно было повторно выбрать тот же файл.
//   if (completeImagesInput.value) {
//     completeImagesInput.value.value = null
//   }
// }

// function removeCompleteImage(index) {
//   errors.state = false
//   errors.errorText = ''

//   const urlToRevoke = completePreviewUrls.value[index]
//   if (urlToRevoke) URL.revokeObjectURL(urlToRevoke)

//   completePreviewUrls.value.splice(index, 1)
//   completeSelectedFiles.value.splice(index, 1)
//   if (completePreviewUrls.value.length === 0) {
//     resetCompleteImages()
//   }
// }

const errors = reactive({
  state: false,
  errorText: ''
})

async function viewFilesTask() {
  isModalFilesActive.value = true
}
async function viewManualTask() {
  isModalManualActive.value = true
}
async function completeTask(){
  resetCompleteImages()
  isModalCompleteActive.value = true
}
async function takeTask(taskId) {
  await tasksStore.takeTask(taskId)
    .then(()=>{})
    // .then(()=>{router.push("/")})
    .catch((error)=>{
      if (error.data?.reason === "active_lunch") {
        // isModalToogleActive.value = true
        errors.errorText = "У Вас не завершен обед"
        isModalErrorActive.value = true
        userStore.atLunch = error.data.lunch
      } else if (error.data?.reason === "no_active_work_day") {
        errors.errorText = "У Вас не начата смена"
        isModalErrorActive.value = true
        userStore.atWork = 0
      }
    })
}
async function checkTask(taskId) {
  await tasksStore.checkTask(taskId)
}
async function onSubmitCompleteTask(task) {
  errors.state = false
  loadingVisible.value = true
  const formData = new FormData()
  const factAmount = Number(taskCompleteAmount.value)
  if (0 < factAmount && factAmount <= task.amount) {
    formData.append('fact_amount', String(factAmount))
  }

  if (completeSelectedFiles.value?.length) {
    completeSelectedFiles.value.forEach((file) => {
      formData.append('files', file, file.name)
    })
  }

  return tasksStore
    .completeTask(task.id, formData)
    .then(() => {
      setTimeout(() => {
        loadingVisible.value = false
        isModalCompleteActive.value = false
      }, 1000)
    })
    .catch(() => {
        errors.errorText = 'somethingWrong'
        errors.state = true
        loadingVisible.value = false
      })
}

function getPath(url) {
  let u = new URL(url)
  return `${u.pathname}`
}

watch(
  isModalCompleteActive,
  (active) => {
    if (!active) {
      errors.state = false
      errors.errorText = ''
      resetCompleteImages()
    }
  }
)

onBeforeUnmount(() => {
  resetCompleteImages()
})

function handleControlFileErrors(data) {
  errors.state = data.state;
  errors.errorText = data.errorText
}

</script>

<template>
  <CardBox>
    <LoaderFullPage :loading-visible="loadingVisible" />
    <CardBoxModal
      v-model="isModalErrorActive"
      title="Ошибка"
      button-label="Ok"
      @confirm="isModalErrorActive = false"
      widthClass='w-11/12 md:w-4/5 lg:w-3/5 xl:w-6/12'
    >
        <p>{{ errors.errorText }}</p>
    </CardBoxModal>
    <CardBoxModal
      v-model="isModalManualActive"
      title="Инструкция"
      button-label="Ok"
      @confirm="isModalManualActive = false; errors.errorText = ''"
      widthClass='w-11/12 md:w-4/5 lg:w-3/5 xl:w-6/12'
    >
      <div>
        <p>{{ task.manual }}</p>
        <p>{{ task?.product.manual }}</p>
        <div v-if="task.product.files.length > 0" class="container mx-auto px-5 py-2 lg:px-32 lg:pt-12">
          <div class="-m-1 flex flex-wrap md:-m-2">
            <template v-for="file in task.product.files" :key="file.id" >
              <div v-if="file.file" class="flex w-1/2 flex-wrap">
                <div class="w-full p-1 md:p-2">
                  <img
                    alt="gallery"
                    class="block h-full w-full rounded-lg object-cover object-center"
                    :src="`${getPath(file.file)}`" />
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <BaseDivider />
    </CardBoxModal>
    <CardBoxModal
      v-model="isModalFilesActive"
      title="Файлы"
      button-label="Ok"
      @confirm="isModalFilesActive = false"
      widthClass='w-11/12 md:w-4/5 lg:w-3/5 xl:w-6/12'
    >
      <div class="container mx-auto px-5 py-2 lg:px-32 lg:pt-12">
        <div class="-m-1 flex flex-wrap md:-m-2">
          <template v-for="file in task.files" :key="file.id" >
            <div v-if="file.file" class="flex w-1/2 flex-wrap">
              <div class="w-full p-1 md:p-2">
                <img
                  alt="gallery"
                  class="block h-full w-full rounded-lg object-cover object-center"
                  :src="`${getPath(file.file)}`" />
              </div>
            </div>
          </template>
        </div>
      </div>
    </CardBoxModal>
    <CardBoxModal
      v-model="isModalCompleteActive"
      title="Завершение задачи"
      button-label="Ok"
      has-cancel
      :button-disabled="taskCompleteAmount < 0"
      @confirm="onSubmitCompleteTask(task)"
      widthClass='w-11/12 md:w-4/5 lg:w-3/5 xl:w-6/12'
    >
      <FormField label="Выполнено частично" help="Если выполнено полностью, не заполнять">
        <FormControl v-model="taskCompleteAmount" type="money" :precision="0" inputmode="numeric"
          name="taskCompleteAmount" required />
      </FormField>

      <FormField label="Фото">
        <FormControlFile
          v-model="completeSelectedFiles"
          accept="image/*"
          label-btn="Выбрать фото"
          @errors="handleControlFileErrors"
          preview/>
      </FormField>
      <!-- <div class="flex flex-col gap-3">
          <div class="flex items-center justify-between gap-3">
            <span class="text-sm text-gray-500 dark:text-slate-300">
              Подгружено фото: {{ completeSelectedFiles.length }}/{{ MAX_COMPLETE_FILES }}
            </span>
          </div>

          <div class="flex items-stretch justify-start relative">
            <label class="inline-flex">
              <BaseButton
                as="a"
                :icon="mdiUpload"
                label="Выбрать фото"
                color="info"
                :rounded-full="false"
              />
              <input
                ref="completeImagesInput"
                type="file"
                accept="image/*"
                multiple
                class="absolute top-0 left-0 w-full h-full opacity-0 outline-none cursor-pointer -z-1"
                @change="onCompleteImagesChange"
              />
            </label>
          </div>

          <div
            v-if="completePreviewUrls.length"
            class="grid grid-cols-2 sm:grid-cols-3 gap-2"
          >
            <div
              v-for="(url, index) in completePreviewUrls"
              :key="url"
              class="relative rounded-lg overflow-hidden"
            >
              <img :src="url" alt="preview" class="w-full h-28 object-cover" />
              <button
                type="button"
                class="absolute top-1 right-1 bg-white/80 dark:bg-slate-800/80
                       text-red-600 dark:text-red-400 rounded-full
                       px-2 py-0.5 text-xs hover:bg-white"
                @click="removeCompleteImage(index)"
              >
                Удалить
              </button>
            </div>
          </div>
        </div> -->
      <NotificationBar v-if="errors.state" color="danger">
        {{ errors.errorText }}
      </NotificationBar>
    </CardBoxModal>
    <BaseLevel mobile>
      <div>
        <h3 class="text-2xl">
          <span class="leading-tight text-gray-500 dark:text-slate-400">Поставка:</span> {{task?.assembling?.town.title}} на {{ parseDate(task?.assembling?.date) }}
        </h3>
        <p><span class="text-lg leading-tight text-gray-500 dark:text-slate-400">Вид работы:</span> {{ task?.work_type.name }} </p>
        <p><span class="text-lg leading-tight text-gray-500 dark:text-slate-400">Продукт:</span> {{ task?.product.title }} </p>
        <p><span class="text-lg leading-tight text-gray-500 dark:text-slate-400">Количество:</span> {{ task?.amount }} </p>
        <p><span class="text-lg leading-tight text-gray-500 dark:text-slate-400">Маркетплейс:</span> {{ task?.marketplace.title }} </p>
        <p v-if="task?.first_user_main"><span class="text-lg leading-tight text-gray-500 dark:text-slate-400">Основной исполнитель:</span> @{{ task.first_user_main.username }}</p>
        <p v-if="task.second_user_available && !task.second_user">Возможно наличие помощника</p>
        <p v-if="task?.second_user_main"><span class="text-lg leading-tight text-gray-500 dark:text-slate-400">Помощник:</span> @{{ task.second_user_main.username }}</p>
        <p v-if="task.start"><span class="text-lg leading-tight text-gray-500 dark:text-slate-400">Начало:</span> {{parseTimestamp(task.start)}}</p>
        <p v-if="task.end"><span class="text-lg leading-tight text-gray-500 dark:text-slate-400">Окончание:</span> {{parseTimestamp(task.end)}}</p>
        <p v-if="task.checked_it_out_user_main"><span class="text-lg leading-tight text-gray-500 dark:text-slate-400">Проверено:</span> @{{task.checked_it_out_user_main.username}}</p>
      </div>
    </BaseLevel>
    <footer>
      <span class="flex justify-end mt-2">
        <BaseButtons type="justify-start" no-wrap>
          <BaseButton
            v-if="task?.files.length > 0"
            color="info"
            :icon="mdiEyeOutline"
            small
            tooltip-title="Файлы"
            @click="viewFilesTask"
          />
          <BaseButton
            color="info"
            :icon="mdiTextBoxOutline"
            small
            tooltip-title="Инструкция"
            @click="viewManualTask"
          />
          <BaseButton
            v-if="task?.first_user_main?.id === userStore.id && !task.end"
            color="success"
            :icon="mdiCheck"
            small
            tooltip-title="Выполнено"
            @click="completeTask"
          />
          <BaseButton
            v-if="userStore.can('take_tasks') && canTake && task?.first_user_main?.user_id !== userStore.id"
            color="warning"
            :icon="mdiCheckboxMarkedCircleAutoOutline"
            small
            tooltip-title="Взять"
            @click="takeTask(task.id)"
          />
          <BaseButton
            v-if="userStore.can('check_tasks') && task.end && !task.checked"
            color="danger"
            :icon="mdiCheckboxMarkedCirclePlusOutline"
            small
            tooltip-title="Проверено"
            @click="checkTask(task.id)"
          />
        </BaseButtons>
      </span>
    </footer>
  </CardBox>
</template>
